import { render, staticRenderFns } from "./PlasticLayer.vue?vue&type=template&id=29fcf581&scoped=true&"
import script from "./PlasticLayer.vue?vue&type=script&lang=js&"
export * from "./PlasticLayer.vue?vue&type=script&lang=js&"
import style0 from "./PlasticLayer.vue?vue&type=style&index=0&id=29fcf581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fcf581",
  null
  
)

export default component.exports